<template>
  <div>
    <Header />
    <div class="app-container">
      <div class="container">
        <router-view></router-view>
      </div>
    </div>
    <Foooter />
  </div>
</template>

<script>
import Header from "./Header.vue";
import Foooter from "./Footer.vue";
export default {
  components: {
    Header,
    Foooter,
  },
};
</script>